import { IconProps } from "@/data/types"

export default function LanguageIcon({ width=24, height=24, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.1543 3.30273C12.4869 4.22028 10.5993 5.9564 10.5993 7.43466C10.5993 9.32452 12.5745 9.72852 14.1543 9.42267C15.7341 9.11682 17.5772 8.19928 18.1037 9.42267C18.6303 10.6461 17.0506 11.8185 18.1037 13.3477C18.9463 14.5711 20.3856 14.2038 20.9999 13.9999M6 18.5C6 16.5 7.78297 12.2197 9.94177 13.3477C11.3563 14.0868 10.8643 16.3321 12.1133 17.7825C13.1668 19.0059 14.3844 17.7825 15.1414 19.9999" stroke={color}/>
      </svg>
    </div>
  )
}